import { ModuleWithProviders, NgModule } from '@angular/core';

import { RtUICommonModule } from '../common/common.module';
import { TourHighlightComponent } from './tour-highlight.component';
import { TourHighlightDirective } from './tour-highlight.directive';
import { TourHighlightService } from './tour-highlight.service';

@NgModule({
  imports: [RtUICommonModule],
  declarations: [TourHighlightComponent, TourHighlightDirective],
  exports: [TourHighlightDirective, TourHighlightComponent],
})
export class RtUITourHighlightModule {
  public static forRoot(): ModuleWithProviders<RtUITourHighlightModule> {
    return {
      ngModule: RtUITourHighlightModule,
      providers: [TourHighlightService],
    };
  }
}

export { TourHighlightService, TourHighlightDirective, TourHighlightComponent };
